(function () {
  'use strict';

  if (window.OakDeliveryEstimator) return;

  var mapPromise;

  function loadMap(url) {
    if (!mapPromise) {
      mapPromise = fetch(url, { credentials: 'same-origin' }).then(function (response) {
        if (!response.ok) throw new Error('Unable to load delivery prefix map.');
        return response.json();
      });
    }
    return mapPromise;
  }

  function findPrefix(prefix, map) {
    if (map.prefixes && map.prefixes[prefix]) return map.prefixes[prefix];

    var prefixNumber = Number(prefix);
    var ranges = Array.isArray(map.ranges) ? map.ranges : [];
    for (var index = 0; index < ranges.length; index += 1) {
      if (prefixNumber >= ranges[index].from && prefixNumber <= ranges[index].to) {
        return ranges[index];
      }
    }
    return null;
  }

  function localDate(baseDate, additionalDays) {
    return new Date(
      baseDate.getFullYear(),
      baseDate.getMonth(),
      baseDate.getDate() + additionalDays
    );
  }

  function monthName(date) {
    return date.toLocaleDateString('en-IN', { month: 'long' });
  }

  function formatDateRange(minDate, maxDate) {
    var sameYear = minDate.getFullYear() === maxDate.getFullYear();
    var sameMonth = sameYear && minDate.getMonth() === maxDate.getMonth();

    if (sameMonth) {
      return minDate.getDate() + '–' + maxDate.getDate() + ' ' + monthName(maxDate);
    }

    if (sameYear) {
      return minDate.getDate() + ' ' + monthName(minDate) + '–' +
        maxDate.getDate() + ' ' + monthName(maxDate);
    }

    return minDate.getDate() + ' ' + monthName(minDate) + ' ' + minDate.getFullYear() + '–' +
      maxDate.getDate() + ' ' + monthName(maxDate) + ' ' + maxDate.getFullYear();
  }

  function calculate(pin, map, baseDate) {
    if (!/^\d{6}$/.test(pin)) return { status: 'invalid' };

    var prefix = pin.slice(0, 3);
    var region = findPrefix(prefix, map);
    if (!region) return { status: 'unknown' };

    var dispatchDays = Number(map.dispatch_days) || 1;
    var minDays = dispatchDays + Number(region.transit_min_days);
    var maxDays = dispatchDays + Number(region.transit_max_days);
    var today = baseDate instanceof Date ? baseDate : new Date();
    var minDate = localDate(today, minDays);
    var maxDate = localDate(today, maxDays);

    return {
      status: 'success',
      prefix: prefix,
      region: region.region,
      minDays: minDays,
      maxDays: maxDays,
      minDate: minDate,
      maxDate: maxDate,
      dateRange: formatDateRange(minDate, maxDate)
    };
  }

  function bind(options) {
    var input = options.input;
    var button = options.button;
    var message = options.message;
    if (!input || !button || !message || input.dataset.deliveryEstimateBound === 'true') return;

    input.dataset.deliveryEstimateBound = 'true';
    var inFlight = false;
    var lastRequestKey = '';

    function show(text, isError) {
      message.hidden = false;
      message.textContent = text;
      message.classList.toggle('is-error', isError);
      message.style.color = isError ? '#d9534f' : '#1b6938';
    }

    function setBusy(isBusy) {
      inFlight = isBusy;
      button.disabled = isBusy;
      button.setAttribute('aria-disabled', isBusy ? 'true' : 'false');
      message.setAttribute('aria-busy', isBusy ? 'true' : 'false');
    }

    function submit() {
      if (inFlight) return;

      var pin = (input.value || '').trim();
      if (!/^\d{6}$/.test(pin)) {
        lastRequestKey = '';
        show(options.invalidMessage || 'Please enter a valid 6 digit Indian PIN code.', true);
        return;
      }

      var now = new Date();
      var requestKey = pin + '|' + now.getFullYear() + '-' + now.getMonth() + '-' + now.getDate();
      if (requestKey === lastRequestKey) return;

      setBusy(true);
      loadMap(options.mapUrl)
        .then(function (map) {
          var estimate = calculate(pin, map, now);
          if (estimate.status === 'unknown') {
            show(map.unknown_region_message || 'We couldn’t identify this PIN region. Please check and try again.', true);
          } else {
            show('Estimated delivery: ' + estimate.dateRange, false);
          }
          lastRequestKey = requestKey;
        })
        .catch(function () {
          show('We couldn’t identify this PIN region. Please check and try again.', true);
        })
        .finally(function () {
          setBusy(false);
        });
    }

    button.addEventListener('click', submit);
    input.addEventListener('focus', function () {
      if (!message.hidden && /^\d{6}$/.test(input.value)) {
        input.select();
      }
    });
    input.addEventListener('input', function () {
      lastRequestKey = '';
      if (!inFlight) {
        message.hidden = true;
        message.textContent = '';
        message.classList.remove('is-error');
        message.removeAttribute('aria-busy');
      }
    });
    input.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        submit();
      }
    });
  }

  window.OakDeliveryEstimator = {
    bind: bind,
    calculate: calculate,
    findPrefix: findPrefix,
    formatDateRange: formatDateRange
  };
  document.dispatchEvent(new CustomEvent('oak:delivery-estimator-ready'));
})();
